export function formatCategoryHeading(categoryName, subjectName) {
  const classLabel = formatClassLabel(categoryName);
  const subjectLabel = subjectName ? ` ${capitalizeWords(subjectName)}` : '';
  return `${classLabel}${subjectLabel} Courses`;
}

export function formatHeroTitle(categoryName, subcategoryName) {
  const classLabel = formatClassLabel(categoryName);
  if (subcategoryName) {
    return `Everything for ${classLabel} ${subcategoryName} Students`;
  }
  return `Everything for ${classLabel} Students`;
}

function formatClassLabel(categoryName = '') {
  const trimmed = String(categoryName).trim();
  if (!trimmed) return 'CHSE';
  if (/\bth\b/i.test(trimmed)) return trimmed;
  return trimmed.replace(/(\d+)\s*$/, '$1th').replace(/Class\s+(\d+)th/i, 'Class $1');
}

function capitalizeWords(value = '') {
  return String(value)
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

export function normalizeSubjectName(name = '') {
  return capitalizeWords(name);
}
